import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Divider,
  Tab,
  Tabs,
  TabList,
  TabPanels,
  TabPanel,
  TabText,
  Typography,
} from '@tq/ui-components';

import { AddNote, AddNoteButton, Notes, NotesInfoMessage } from 'components';
import { Consultation } from 'types';
import { CaseDetailsCard, CaseOfficerDetailsCard } from '..';
import { useCanAddNote } from 'hooks';

export type MobileSummaryProps = {
  consultation?: Consultation;
  isLoading: boolean;
};

export const MobileSummary: React.FC<MobileSummaryProps> = ({ consultation, isLoading }) => {
  const { t } = useTranslation('summary_header');
  const canAddNote = useCanAddNote(consultation);
  return (
    <Tabs variant='line' p={0} mx={-4}>
      <TabList>
        <Tab>
          <TabText>{t('case_details', 'Case details')}</TabText>
        </Tab>
        <Tab>
          <TabText>{t('notes', 'Notes')}</TabText>
        </Tab>
      </TabList>
      <TabPanels py={6}>
        <TabPanel py={0} border={0}>
          <CaseDetailsCard consultation={consultation} />
          <Typography mt={5} mb={2}>
            <h2>{t('case_officer_details', 'Case officer details')}</h2>
          </Typography>
          <CaseOfficerDetailsCard consultation={consultation} />
        </TabPanel>
        <TabPanel py={0} border={0}>
          {canAddNote && (
            <>
              <NotesInfoMessage consultation={consultation} />
              <AddNoteButton consultation={consultation} />
              <Divider my={4} />
            </>
          )}
          <AddNote />
          <Box mt={6}>
            <Notes notes={consultation?.notes} loading={isLoading} />
          </Box>
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
